import { render } from "./AgentActionResizeCache.vue?vue&type=template&id=2f17225b&scoped=true"
import script from "./AgentActionResizeCache.vue?vue&type=script&lang=js"
export * from "./AgentActionResizeCache.vue?vue&type=script&lang=js"

import "./AgentActionResizeCache.vue?vue&type=style&index=0&id=2f17225b&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f17225b"]])

export default __exports__